import React, { Component } from 'react';
import {
  Modal,
  Row,
  Col,
  InputNumber,
  Input,
  Typography,
  Space,
  message,
  Select,
  Alert
} from 'antd';
import { SaveOutlined, DollarOutlined, } from '@ant-design/icons';
import {
  ButtonItem,
  SelectItem,
  SwitchItem
} from '../../../Components/Items';
import axios from 'axios';

const { Text } = Typography;
const { Option } = Select;

class ModalRetiroCaja extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monto: 0,
      descripcion: '',
      loading: false,
      todasBancos: [],
      objetoBancos: [],
      permitirOtrosRetiros: false,
      otrosRetiros: false,
      bancoId: null,
      saldoFinal: 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.consultarTodo();
    }
  }

  consultarTodo = () => {
    //Traer las cajas chicas de retiros para mostrar en el select
    this.setState({ loading: true });
    axios.post(
      'cajas/consultarCajasChicasRetiros',
      {
        sesionId: this.props.sesionId,
        empresaId: this.props.empresaId,
      },
      {
        headers: this.props.headersToken,
      }
    ).then((res) => {
      this.setState({ loading: false });
      if (res.data.success === 2) {
        this.setState({
          todasBancos: res.data.bancos,
          objetoBancos: res.data.bancos.map((banco) => (
            <Option key={banco._id} value={banco._id}>
              {banco.nombre + (banco.descripcion ? (' - ' + banco.descripcion) : '')}
            </Option>
          )),
          permitirOtrosRetiros: res.data.permitirOtrosRetiros,
          saldoFinal: res.data.saldoFinal,
        })
      } else {
        message.error(res.data.message ? res.data.message : 'Error al consultar las cajas chicas de retiros');
      }
    }).catch((error) => {
      this.setState({ loading: false });
      console.error('Error al consultar las cajas chicas de retiros:', error);
      message.error('Error al consultar las cajas chicas de retiros');
    }).finally(() => {
      this.setState({ loading: false });
    })
  }

  handleGuardar = async () => {
    const { monto, descripcion, otrosRetiros, bancoId, saldoFinal} = this.state;
    if (monto > saldoFinal) {
      message.error(`El monto no puede ser mayor al saldo disponible ($${saldoFinal.toFixed(2)}).`);
      return; 
    }

    if (monto <= 0) {
      message.warning('El monto debe ser mayor a cero.');
      return;
    }

    if (!descripcion.trim()) {
      message.warning('La descripción es obligatoria.');
      return;
    }

    if (!otrosRetiros && !bancoId) {
      message.warning('Debe seleccionar una cuenta de retiro.');
      return;
    }

    this.setState({ loading: true });

    try {
      const res = await axios.post(
        'cajas/guardarRetiro',
        {
          montoRetiro: monto,
          descripcion,
          otrosRetiros: otrosRetiros,
          bancoId: bancoId,
          sesionId: this.props.sesionId, // Asumiendo que recibes sesionId como prop
          empresaId: this.props.empresaId,
        },
        {
          headers: this.props.headersToken, // Asumiendo que tienes headersToken en props
        }
      );

      if (res.data.success === 2) {
        message.success('Retiro guardado correctamente');
        this.setState({ monto: 0, descripcion: '', bancoId: null, otrosRetiros: false });
        this.props.onCancel(); // Cerrar modal
      } else {
        message.error(res.data.message ? res.data.message : 'Error al guardar el retiro: ');
      }

      // Simulando éxito
    } catch (error) {
      console.error('Error al guardar el retiro:', error);
      message.error('Error al guardar el retiro');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleCancel = () => {
    if (this.state.loading) return;
    this.props.onCancel();
  };

  render() {
    const { visible } = this.props;
    const { monto, descripcion, loading, objetoBancos, permitirOtrosRetiros, otrosRetiros, bancoId, saldoFinal } = this.state;

    return (
      <Modal
        title={
          <Space>
            <DollarOutlined style={{ color: '#00b5e2' }} />
            <span>Retiro de Caja</span>
          </Space>
        }
        visible={visible}
        onCancel={this.handleCancel}
        footer={null}
        centered
        closable={!loading}
        maskClosable={!loading}
      >
        <Row>
          <Col span={24}>
            <Text strong>Saldo Máximo Disponible:</Text>
            <Alert message={`$${saldoFinal.toFixed(2)}`} type="success" showIcon style={{ marginTop: 4, marginBottom: 4 }} />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          {permitirOtrosRetiros && (
            <>
              <Col span={12}>
                <Text strong>Otros Retiros:</Text>
              </Col>
              <Col span={12}>
                <SwitchItem
                  value={otrosRetiros}
                  onChange={(value) => this.setState({ otrosRetiros: value })}
                  disabled={loading}
                />
              </Col>
            </>
          )}
          {!otrosRetiros && (
            <Col span={24}>
              <Text strong>Cuenta Retiro:</Text>
              <SelectItem
                value={bancoId}
                onChange={(value) => this.setState({ bancoId: value })}
                style={{ width: '100%' }}
                disabled={loading}
              >
                {objetoBancos}
              </SelectItem>
            </Col>
          )}
          <Col span={24}>
            <Text strong>Monto a retirar:</Text>
            <InputNumber
              value={monto}
              onChange={(value) => this.setState({ monto: value || 0 })}
              style={{ width: '100%' }}
              min={0}
              precision={2}
              disabled={loading}
            />
          </Col>
          <Col span={24}>
            <Text strong>Descripción:</Text>
            <Input.TextArea
              value={descripcion}
              onChange={(e) => this.setState({ descripcion: e.target.value })}
              rows={3}
              disabled={loading}
            />
          </Col>
        </Row>

        <div style={{ marginTop: 24, textAlign: 'center' }}>
          <Space>
            <ButtonItem
              type="primary"
              icon={<SaveOutlined />}
              onClick={this.handleGuardar}
              loading={loading}
              style={{
                backgroundColor: '#00b5e2',
                borderColor: '#00b5e2',
                height: '40px',
                paddingLeft: '24px',
                paddingRight: '24px',
              }}
            >
              {loading ? 'Guardando...' : 'Guardar Retiro'}
            </ButtonItem>
            <ButtonItem
              onClick={this.handleCancel}
              disabled={loading}
              rojo
              style={{ height: '40px', paddingLeft: '24px', paddingRight: '24px' }}
            >
              Cancelar
            </ButtonItem>
          </Space>
        </div>
      </Modal>
    );
  }
}

export default ModalRetiroCaja;
